import api from './api';

const expenseAbatesService = {
  // Listar todos os abates
  getAllAbates: async (params = {}) => {
    const response = await api.get('/expense-abates', { params });
    return response.data;
  },

  // Listar abates pendentes
  getPendingAbates: async () => {
    const response = await api.get('/expense-abates/pending');
    return response.data;
  },

  // Listar abates por projeto
  getAbatesByProject: async (projectId) => {
    const response = await api.get(`/expense-abates/project/${projectId}`);
    return response.data;
  },

  // Listar abates por custo
  getAbatesByCost: async (costId) => {
    const response = await api.get(`/expense-abates/cost/${costId}`);
    return response.data;
  },

  // Obter abate por ID
  getAbateById: async (id) => {
    const response = await api.get(`/expense-abates/${id}`);
    return response.data;
  },

  // Criar abate
  createAbate: async (abateData) => {
    const response = await api.post('/expense-abates', abateData);
    return response.data;
  },

  // Marcar abate como pago
  markAbateAsPaid: async (id, paymentData) => {
    const response = await api.post(`/expense-abates/${id}/pay`, paymentData);
    return response.data;
  },

  // Cancelar abate
  cancelAbate: async (id) => {
    const response = await api.delete(`/expense-abates/${id}`);
    return response.data;
  },

  formatCurrency: (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value || 0);
  }
};

export default expenseAbatesService;